import { BusinessError, businessErrorFactory } from '../../../../../../common/business-error';

const USER_ROLE_UPDATE_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error while processing your user role update. Please try again. If the problem still persists, contact with support.';
export const getUserRoleUpdateBusinessError = (): BusinessError =>
  businessErrorFactory({
    message: USER_ROLE_UPDATE_UNEXPECTED_ERROR,
    severity: 'error'
  });
